<template>
  <div class="standard_trade">
    <AntGridSkeleton height="10rem" :num="6" :rows="2" :gap="0.7" :loading="skeletonLoading">
      <div class="antd-row">
        <div class="antd-col" v-for="(item,index) in data" :key="index">
          <Threshold :data="item" :rows="6" :skip="skip" />
        </div>
      </div>
    </AntGridSkeleton>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      skeletonLoading: true,
      data: [],
      dataSource: [],
      cancells: this.$FN.cancells(),
      img: require('@/assets/images/public/no_data.jpg')
    }
  },
  created() {
    this.getData();
  },
  methods: {
    skip(data, mode = "original") {
      this.$FN.limitsTips({ list: ["home_standardTrade_details"] }).then(res => {
        if (res) {
          let { id } = data;
          let key = 'regulations';
          let path = '/detailsPage/industryInformationBase';
          let type = '2';
          let title = { chinese: '国别技术法规', english: 'Trade threshold' };
          this.$router.$push({ path, query: { id, key, type, ...title, mode, backPath: "/technicalRegulations" } });
        }
      });
    },
    getData() {
      let form = { pageNum: 1, pageSize: 6, internationalIndustryType: '7' };
      this.loading = true;
      this.$FN.get("/infomation/regulations/list", form).then(res => {
        this.loading = false;
        this.skeletonLoading = false;
        if (res) {
          let { rows = [] } = res;
          this.dataSource = rows;
          this.setData();
        }
      });
    },
    setData() {
      this.data = this.dataSource.map(item => {
        item.loading = false;
        item.imgUrl = item.imgUrl ? `${this.$FN.filesPublic}${item.imgUrl}` : this.img;
        let obj = {
          id: item.id,
          loading: false,
          imgUrl: item.imgUrl ? `${this.$FN.filesPublic}${item.imgUrl}` : this.img,
          title: this.$L({ chinese: item.title, english: item.titleTrans }),
          countryText: this.$L({ chinese: item.countryText, english: item.countryTextEn }),
          stateText: this.$L({ chinese: item.stateText, english: item.stateTextEn }),
          lawsTypeText: this.$L({ chinese: item.lawsTypeText, english: item.lawsTypeTextEn }),
          viewsCount: item.viewsCount
        };
        return obj;
      });
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>